export default "__VITE_ASSET__CXY8Y9h0__"